export class TypeAssistancesSubCategories {
  static readonly APPEL_D_OFFRES = 'APPEL_D_OFFRES';
  static readonly ARBITRAGE = 'ARBITRAGE';
  static readonly ARBITRAGE_CHANGEMENT_INDEX = 'ARBITRAGE_CHANGEMENT_INDEX';
  static readonly ARBITRAGE_PASSAGE_TAUX_FIXE = 'ARBITRAGE_PASSAGE_TAUX_FIXE';
  static readonly ARBITRAGE_REMBOURSEMENT_ANTICIPE = 'ARBITRAGE_REMBOURSEMENT_ANTICIPE';
  static readonly ASSISTANCE_PERSONNALISEE = 'ASSISTANCE_PERSONNALISEE';
  static readonly AUDIT = 'AUDIT';
  static readonly AUDIT_ANNUEL = 'AUDIT_ANNUEL';
  static readonly AUDIT_INITIAL = 'AUDIT_INITIAL';
  static readonly AUTRE = 'AUTRE';
  static readonly LIGNE_DE_TRESORERIE = 'LIGNE_DE_TRESORERIE';
  static readonly MARCHES_ET_STRATEGIES = 'MARCHES_ET_STRATEGIES';
  static readonly PRICING = 'PRICING';
  static readonly REAMENAGEMENT = 'REAMENAGEMENT';
  static readonly RECOMMANDATION_ALERTE = 'RECOMMANDATION_ALERTE';
  static readonly REGLEMENTAIRE = 'REGLEMENTAIRE';
  static readonly FINANCEMENT_DIRECT = 'FINANCEMENT_DIRECT';
  static readonly GESTION_DE_TRESORERIE = 'GESTION_DE_TRESORERIE';
  static readonly ETAT_DE_LA_DETTE = 'ETAT_DE_LA_DETTE';
  static readonly VISITE_CLIENT = 'VISITE_CLIENT';
  static readonly POINT_CLIENT = 'POINT_CLIENT';
  static readonly APPEL_PROACTIF = 'APPEL_PROACTIF';
  static readonly SONDAGE = 'SONDAGE';
  static readonly RAPPORT_RETRO_PROSPECTIVE = 'RAPPORT_RETRO_PROSPECTIVE';
  static readonly CADRAGE = 'CADRAGE';
}
